import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_CON024_Request,
  IAPI_CON024_Response,
} from "../../../type/apiType";

// 契約者申請情報参照
const httpAPI_CON024 = async (
  param: IAPI_CON024_Request
): Promise<IAPI_CON024_Response> => {
  let res = await http.post(ApiUrl.API_CON024, {
    ...param,
  });

  return res.data;
};

// 申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON024, httpAPI_APP016 };
